<template>
  <div class="general-settings">
    <div class="columns">
      <div class="column padding-left-0">
        <p class="description">Customise the general settings related to the emails sent to your customers.</p>
        <!-- Settings Form Begins -->
        <div class="columns is-block">
          <div class="column is-full padding-left-0 padding-bottom-0 padding-top-0">
            <label for="">From Name</label>
            <input type="text" class="input" placeholder="Your name here" v-model="settings.email.fromName">
          </div>
          <div class="column is-flex padding-left-0">
            <div class="column padding-left-0">
              <label for="">From Email</label>
              <input type="text" class="input" placeholder="Your email here" v-model="settings.email.fromEmail">
            </div>
            <div class="column padding-right-0">
              <label for="">Reply Email</label>
              <input type="text" class="input" placeholder="Your reply email here" v-model="settings.email.replyEmail">
            </div>
          </div>
        </div> <!-- Settings Form Ends -->
        <div class="columns">
          <div class="column has-text-right">
            <button
              data-track="Portal | Save Review Invite Email Settings"
              class="button is-button-dark-blue save-button"
              :class="[{ 'is-loading': loaders.isSaving }, 'button is-button-blue is-uppercase']"
              @click="handleSaveEmailSettings"
            >
              Save
            </button>
          </div>
        </div>
      </div>
      <div class="column">
        <!-- Template Preview Begins -->
        <div class="right-section column preview has-spinner">
          <h6 class="is-size-7  title-business preview-header">Preview
            <div class="preview-mobile-desktop-icon">
              <div class="preview-toggle-icons">
              <span class="desktop-icon"
                    v-on="isActive ? { click: () => responsive('desktop') } : {click: ($event) => $event.preventDefault() }"
                    :class="{ 'has-text-weight-bold active': !isActive }">
                <img class="ds1" src="/static/img/desktop-icon-white.png">
                <img class="ds2" src="/static/img/desktop-icon-grey1.png">
              </span>
                <span class="mob-icon"
                      v-on="!isActive ? { click: () => responsive('mobile') } : {click: ($event) => $event.preventDefault() }"
                      :class="{ 'has-text-weight-bold active': isActive }">
                <img class="mb1" src="/static/img/mobile-icon-white.png">
                <img class="mb2"  src="/static/img/mobile-icon-grey.png">
              </span>
              </div>
            </div>
          </h6>
          <div v-if="isPreviewing">
            <p class="has-text-centered">
              <img class="has-spinner__spinner" src="/static/img/loaders/spinner.svg" alt="fetching Review Breakdown..." />
            </p>
          </div>
          <iframe :srcdoc="htmlPreview" :width="iframeWidth" height="580" style="margin-top: 20px; transform: scale(0.9); " v-if="!isPreviewing"></iframe>
        </div> <!-- Template Preview Ends -->
      </div>
    </div>
    <ImageLibraryModal
      :show=toggleModal
      :key="reRenderIndex"
      :tabName="tabName"
      :chosenTab="tabName"
      @closeModal="toggleModal=!toggleModal"
      @imageSelected="imageSelected"
    ></ImageLibraryModal>
  </div>
</template>

<script>
/* eslint-disable indent,no-new,no-undef,valid-jsdoc, no-useless-escape */
import axios from 'axios'
import { misc } from '@/mixins'
import ImageLibraryModal from '@/components/ImageLibraryModal.vue'

export default {
  name: 'GeneralSettings',
  mixins: [misc],
  components: {
    ImageLibraryModal
  },
  data () {
    return {
      tabName: '',
      isActive: false,
      isPreviewing: false,
      htmlPreview: '',
      iframeWidth: '600px',
      currentCursor: 'body',
      toggleModal: false,
      reRenderIndex: 0,
      mailType: 'INMAIL', /** ['INMAIL', 'LANDINGPAGE'] */
      loaders: {isSaving: false, isEdited: false},
      business: {orgId: localStorage.getItem('org_id'), slug: localStorage.getItem('org_slug')},
      settings: {email: {fromName: '', fromEmail: '', replyEmail: ''}}
    }
  },
  created () {
    this.getReviewInvitationTemplate('selected')
    this.getEmailSettings()
  },
  methods: {
    /**
     * Get email settings
     * @return {void}
     */
    getEmailSettings () {
      axios.get(`${this.business.orgId}/review-invites/settings`)
      .then(({data}) => {
        Object.assign(this.settings, data.data.settings)
      })
      .catch(({response}) => {
        flash(`${response.data.message}`, 'is-danger')
      })
    },
    /**
     * Handle Action when any Image Selected
     * @return {void}
     */
    imageSelected (img) {
      if (img.image_type === 'HEADER') {
        this.image.header =
          {
            'originalName': img.data.originalName,
            'type': img.data.type,
            'path': img.data.imageForlderUrl + img.data.fileName
          }
      } else {
        this.image.logo =
          {
            'originalName': img.data.originalName,
            'type': img.data.type,
            'path': img.data.imageForlderUrl + img.data.fileName
          }
      }
      this.getReviewInvitationTemplate('preview')
      this.handleFieldChange()
      this.toggleModal = !this.toggleModal
    },
    /**
     * Get the invitation template content for preview
     * @return {void}
     */
    getReviewInvitationTemplate (mode = 'get') {
      let data = {
        type: this.mailType
      }

      if (mode === 'get') {
        data = Object.assign(data, {body: '', subject: '', mode: 'get'})
      } else if (mode === 'selected') {
        data = Object.assign(data, {body: '', subject: '', mode: 'selected'})
      } else {
        data = Object.assign(data, {body: this.body, subject: this.subject, files: this.image, allowToAddPhotos: this.allowToAddPhotos, mode: 'preview'})
      }

      axios.post(`/${this.business.slug}/review/get-invite-template`, data)
      .then((response) => {
        localStorage.setItem('mailType', JSON.stringify(this.mailType))
        this.body = response.data.body
        this.htmlPreview = response.data.view
        this.subject = response.data.subject
        this.tags = response.data.tags
        this.allowToAddPhotos = response.data.allowUserToUpload
        this.image = response.data.attachment
        this.isPreviewing = false
        if (response.data.type !== undefined) {
          this.mailType = response.data.type
        }
      })
      .catch(() => {
        flash('You are not authorized to view this resource.', 'is-danger')
      })
    },
    /**
     * Toggle between Desktop and mobile preview
     * @return {void}
     */
    responsive (type) {
      this.isActive = !this.isActive
      this.iframeWidth = type === 'desktop' ? '600px' : '320px'
    },
    /**
     * Save Email Settings
     * @return {void}
     */
    handleSaveEmailSettings () {
      axios.post(`${this.business.orgId}/review-invites/settings`, this.settings)
      .then(({data}) => {
        this.displaySuccessMsg(data.message, 'Portal - Email Settings Saved')
        this.getEmailSettings()
      })
      .catch(({response}) => {
        flash(response.data.message, 'is-danger')
      })
    }
  }
}
</script>

<style scoped>
/* Invite Template CSS Begins */
.has-spinner__spinner {
  max-width: 60px;
  width: 100%;
}
.label-header {
  font-size: 12px;
  font-weight: 600;
  color: #58595b;
}
.preview-button-color, .preview-button-color:hover{
  width: 30%;
  float: left;
  border: solid 1px #30aae1 !important;
  background-color: #ffffff;
}
.disable-field{
  color: #8a8c91 !important;
}
.input{
  color: #4a4a4a;
}
.invite-template .is-three-quarters, .invite-template .is-three-quarters+.column{
  padding-left: 0px;
}
.invite-template .is-three-quarters .input{
  height: 40px;
  width: 70%;
  float: left;
}
.has-text-danger{
  font-size: 0.9em;
}
.dropdown-with-arrow i {
  position: absolute;
  font-size: 1.4rem;
  color: transparent;
  border: 1px solid #95979b;
  border-right: 0;
  border-top: 0;
  content: " ";
  display: block;
  height: 0.5em;
  pointer-events: none;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  -webkit-transform-origin: center;
  transform-origin: center;
  width: 0.5em;
  margin-top: -0.375em;
  right: 1.125em;
  top: 70%;
}
.dropdown-with-arrow i:before {
  border: 0px;
}
input:focus, textarea:focus, select:focus {
  border-color: #b5b5b5;
}
.photo-row {
  line-height: 33px;
}
.photo-row-img {
  vertical-align: middle;
  margin-right: 10px
}
.photo-row-thumbnail {
  width: 40px;
  height: 40px;
  border: solid 1px #dbdbdb;
  background-color: #FFFFFF;
  border-radius: 50%;
}
.photo-row-remove {
  color: #30aae1;
  margin-top: 5px;
  margin-left: 10px;
  width: 45px;
  height: 17px;
  font-size: 12px;
}
.photo-upload-link {
  font-size: 12px;
  color: #30aae1;
}
.photo-name {
  font-size: 11px;
  color: #58595b;
}
.allow-photo {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  color: #707070;
}
.allow-photo-radio {
  color: #707070;
  font-size: 12px;
  padding: 7px;
}
.tooltip {
  position: absolute;
  left: 115px
}
.tooltip-submission a.tooltip {
  display: inline-block;
  position: absolute;
  left: 110px;
}
.tooltip-logo label a.tooltip {
  display: inline-block;
  position: absolute;
  left: 40px;
}
.tooltip-header label a.tooltip {
  display: inline-block;
  position: absolute;
  left: 90px;
}
.tooltip .tooltiptext {
  visibility: hidden;
  background-color: #f3f3f4;
  color: #fff;
  border-radius: 0px;
  min-height:80px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  top:-37px;
  left: 110px;
  margin-left: -66px;
  opacity: 0;
  transition: opacity 0.3s;
  padding-right: 50px;
}
.tooltip .tooltiptext p {
  width: 180px;
  font-size: 10px;
  font-weight: normal;
  color: #707070;
  padding: 10px 20px;
  text-align: justify;
}
.tooltip .tooltiptext::after {
  content: "";
  position: absolute;
  top: 30%;
  left: -1px;
  margin-left: -19px;
  border-width:10px;
  border-style: solid;
  border-bottom: 10px solid #f3f3f4;
  transform: rotate(270deg);
}
.tooltip:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}
.tooltiptext.submission-type {
  width: 350px !important;
  height: 232px !important;
  background-color: #f3f3f4;
}
.submission-type.tooltiptext p {;
  width: 308px;
  height: 165px;
  font-weight: normal;
  line-height: 1.55;
  font-size: 11px;
  color: #707070;
}
.right-section.column.preview {
  background-image: url("/static/img/review_images/mask-group-34.png");
  padding: 0;
  height: 689px;
  background-size: cover;
}
.review-left-box {
  padding-right: 25px;
}
.preview-header {
  background-color: #f3f3f4;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 27px;
  width: 100%;
}
.save-button {
  width: 130px;
  height: 35px;
}
.tooltip-submission {
  position: relative;
}
.tooltip-logo {
  position: relative;
}
.tooltip-header {
  position: relative;
}
.email-validation {
  margin-top: -17px;
}
.free-biz-fa-lock {
  float: right;
  margin-top: -17px;
  margin-right: 12px;
  color: #cbcbd2;
}
.review-invite-info-box {
  margin-top: -15px;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  color: #707070;
}
.email-horizontal-row {
  margin-left: -13px;
  margin-right: -13px;
  margin-top: 9px;
}
.free-biz-offer-info {
  text-align: center;
  margin-bottom: 27px;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  color: #707070;
}
.free-biz-offer-info a {
  text-decoration: underline;
  color: #30aae1;
}
.free-biz-offer-info a:hover {
  color: #30aae1;
}
.input {
  height: 3.25em !important;
  font-size: 12px;
  color: #707070;
}
.invite-body-textarea {
  height: 3.25em !important;
  font-size: 12px !important;
  color: #707070;
}
.email-customisation-font {
  font-size: 14px;
}
.left-section-box {
  width: 47%;
}
@media  screen and (max-width: 767px) {
  .left-section-box {
    width: 100% !important;
  }
  .right-section.column.preview {
    width: 100% !important;
  }
}
/**/
</style>
  <style scoped>
  .desktop-icon {
    width: 45px;
    display: flex;
    cursor: pointer;
    text-align: center;
    vertical-align: middle;
    align-items: center;
    justify-content: center;
  }
span.desktop-icon.active .ds1 {
  display: block;
}
span.desktop-icon.active .ds2 {
  display: none;
}
span.desktop-icon .ds2 {
  display: block;
}
span.desktop-icon .ds1 {
  display: none;
}
.mob-icon {
  width: 45px;
  display: flex;
  cursor: pointer;
  text-align: center;
  vertical-align: middle;
  align-items: center;
  justify-content: center;
  padding: 9px;
}
.mob-icon.active .mb1 {
  display: block;
}
.mob-icon.active .mb2 {
  display: none;
}
.mob-icon .mb1 {
  display: none;
}
span.mob-icon.active,span.desktop-icon.active {
  background: #909ea9;
}
span.desktop-icon,span.mob-icon {
  background: #fff;
}
.preview-mobile-desktop-icon {
  display: flex;
  float: right;
  margin-right: 23px;
  margin-top: -6px;
  height: 36px;
}
.preview-mobile-desktop-icon .preview-toggle-icons {
  display: inline-flex;
  border: 2px solid #d3d3d3;
  border-radius: 2px;
}
.allow-photo-ul {
  margin-left: -7px;
}
</style>
<style>
.invite-template {
  margin-top: 28px;
}
.left-section{
  padding-left: 0;
}
.add-tag {
  cursor: pointer;
}
.tags li {
  padding: 5px;
  background-color: rgba(138, 140, 145, 0.1);
  color: #868282;
}
.disable-field{
  pointer-events: none;
}
.right-section {
  max-width: 100%;
}
.left-email-box {
  border: 1px solid #CCCCCC;
  max-width: 100%;
  margin-top: 15px;
}
iframe {
  max-width: 100%;
  margin: 0px auto;
  display: block;
  padding: 0 25px;
}
.responsive-action{
  text-align: center;
  margin-bottom: 10px;
}
.responsive-action span{
  cursor: pointer;
}
.has-margin-top-1{
  margin-top: 3px;
}
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently supported by Chrome, Opera and Firefox */
}

/*New CSS Begins*/
.general-settings .description {
  color: #58595b;
  margin: 0 0 12px 0;
  font-size: 12px;
}
.general-settings label {
  color: #58595b;
  font-weight: bold;
  font-size: 12px;
}
.general-settings input[type=text] {
  height: 35px !important;
}
/*New CSS Ends*/
</style>



// WEBPACK FOOTER //
// src/pages/collect-reviews/email-settings/GeneralSettings.vue